
import AImage from "@/components/Base/AImage.vue";
import CloudOfflineIcon from "@/components/Base/CloudOfflineIcon.vue";
import useUser from "@/composables/useUser";
import getLocalization from "@/utilities/get-localization";
import { getPhotoUrl } from "@/utilities/get-media-url";
import {
IonCard,
IonCardHeader,
IonCardSubtitle,
IonCardTitle,
IonCol,
IonGrid,
IonRow,
} from "@ionic/vue";
import { PropType, computed, defineComponent } from "vue";
import { useI18n } from 'vue-i18n';
import { useRouter } from "vue-router";
import Property from "../../models/immobilie.model";

export default defineComponent({
  name: "PropertyCard",
  components: {
    CloudOfflineIcon,
    AImage,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonGrid,
    IonRow,
    IonCol,
  },
  props: {
    property: {
      type: Object as PropType<Property>,
      required: true,
    },
    customClickFunction: {
      type: Function,
      default: undefined,
    },
    isSlideMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hover'],
  setup(props, { emit }) {
    const { t } = useI18n({ useScope: 'global' })
    const router = useRouter();
    const { isImmobilienverwalter } = useUser();

    const goToDetailPage = () => {
      router.push({
        path: `/property/${props.property.id}`
      });
    };

    const hover = () => {
      emit('hover');
    }

    const cardClicked = () => {
      if (props.customClickFunction) {
        props.customClickFunction()
        return;
      }
      goToDetailPage()
    }

    /**
     * Support only one label in slide mode but with a notice like "Heizungsbestandsaufnahme +2"
     * otherwise return full array of ba's that are abgeschlossen or freigegeben
     */
    const baLabels = computed(() => {

      const labels: any[] = [];
      let extraLabelsCounted = 0;
      props.property?.bestandsaufnahmes?.forEach((el) => {

        const name = el.name && getLocalization(el.name);
        if (!name) { return; }

        if (labels.indexOf(name) === -1 && ( (el.status === "ABGESCHLOSSEN" && !isImmobilienverwalter() ) || el.status === "FREIGEGEBEN")) {
          if (props.isSlideMode && labels.length >= 1) {
            extraLabelsCounted += 1;
          } else {
            labels.push(name)
          }
        }
      })

      if (extraLabelsCounted > 0) {
        labels[0] += ` +${extraLabelsCounted}`;
      }

      if (labels.length > 1) {
        return ['Gebäudeaufnahme']
      }

      return labels;
    })

    return { router, goToDetailPage, getPhotoUrl, hover, cardClicked, t, baLabels };
  },
});
